import * as areaApi from '../../api/areaApi'

const state = {
    AreaList :[]
}

const getters = {

}

const actions = {
    async GetAreaList({ commit }) {
        let response = await areaApi.GetArea();
        if (response) {
            commit('setAreaList', response)
        }
    }
}

const mutations = {
    setAreaList(state, list) {
        state.AreaList = list
    }
}


export default {
    namespaced: true,
    getters,
    state,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/area.js